import React, {FunctionComponent, useMemo} from 'react';
import './PathFinderControls.css';
import {IQueryParams} from '../../../types/IQueryParams';
import {ILanguage} from '../../../types/ILanguage';
import ControlsWrapper from './ControlsWrapper/ControlsWrapper';
import {IBuilding} from '../../../types/IBuilding';
import ControlsLeft from './ControlsLeft/ControlsLeft';
import ControlsRight from './ControlsRight/ControlsRight';

interface IPathFinderControls {
    building?: IBuilding;
    queryParams: IQueryParams;
    buildingLangs: ILanguage[];
    translateText: (id: number) => string;
    multiBuildings?: IBuilding[];
    setQueryParamItem: (key: keyof IQueryParams, value: string) => void;
    onBuildingParamsChanged: (queryBuildingId: string) => void;
    link?: string;
}

const PathFinderControls: FunctionComponent<IPathFinderControls> = (props) => {
    const {
        building,
        queryParams,
        buildingLangs,
        translateText,
        multiBuildings,
        setQueryParamItem,
        onBuildingParamsChanged,
        link
    } = props;

    return (
        <ControlsWrapper>
            <ControlsLeft
                building = {building}
                queryParams = {queryParams}
                buildingLangs = {buildingLangs}
                translateText = {translateText}
                multiBuildings = {multiBuildings}
                setQueryParamItem = {setQueryParamItem}
                onBuildingParamsChanged = {onBuildingParamsChanged}
            />
            <ControlsRight
                queryParams = {queryParams}
                translateText = {translateText}
                building={building}
            />
        </ControlsWrapper>
    )
};

export default PathFinderControls;
